module.exports = __webpack_public_path__ + "img/10.e378d728.jpg";